/**
 *
 * Asynchronously loads the component for 
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/pages/chatbot-view/loadable.js